import React from 'react';

export default function IconSendOutline({fill = '#ffffff', size = 16}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.29765 7.65702L0.333655 2.28302C0.0276546 1.44302 0.890654 0.654016 1.69865 1.03502L14.5767 7.09502C14.7485 7.17577 14.8937 7.30376 14.9955 7.46402C15.0972 7.62428 15.1512 7.81019 15.1512 8.00002C15.1512 8.18985 15.0972 8.37576 14.9955 8.53601C14.8937 8.69627 14.7485 8.82426 14.5767 8.90502L1.69865 14.965C0.890654 15.345 0.0276546 14.555 0.333655 13.717L2.29765 8.34302C2.37854 8.1215 2.37854 7.87853 2.29765 7.65702ZM3.70665 7.14202L2.15965 2.90902L11.3837 7.25002H3.74365C3.73214 7.21374 3.71981 7.17773 3.70665 7.14202ZM3.74265 8.75002C3.73148 8.78628 3.71947 8.82229 3.70665 8.85802L2.15965 13.09L11.3827 8.75002H3.74265Z"
        fill={fill}
      />
    </svg>
  );
}
